import {Component, effect, Input, Signal, signal} from '@angular/core';
import {NbButtonModule, NbSpinnerModule} from "@nebular/theme";
import {Utils} from "../../../../shared/utils";
import {Division} from "../../../../models/division";
import {Group} from "../../../../models/group";
import {Title} from "@angular/platform-browser";
import {StorageService} from "../../../../services/storage.service";
import {GamesService} from "../../../../services/games-service.service";
import {TeamsService} from "../../../../services/teams.service";
import {MatchBoardComponent} from "../match-board/match-board.component";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-scheduled',
  standalone: true,
  imports: [
    TranslateModule,
    NbButtonModule,
    NbSpinnerModule,
    MatchBoardComponent
  ],
  templateUrl: './scheduled.component.html',
  styleUrl: './scheduled.component.scss'
})
export class ScheduledComponent {
  loading = signal<boolean>(false);
  selectedDivisionId = signal<string>('');
  selectedGroupId: string = 'A';
  isLoggedIn = false;
  currentTitle!: string;

  @Input() triggerTabsRefresh!: Signal<string>;
  @Input() currentUserTeamIds = signal<string[]>([]);
  @Input() selectedDivisionIdSignal = signal<string>('');
  @Input() selectedGroupIdSignal = signal<string>('A');

  divisions = signal<Division[]>([]);
  groups = signal<Group[]>([]);
  scheduledMatches = signal<any>({});

  constructor(
    public utils: Utils,
    private readonly title: Title,
    private storageService: StorageService,
    protected teamsService: TeamsService,
    private gamesService: GamesService
  ) {
    effect(() => {
      const refreshTriggeredBy = this.triggerTabsRefresh();
      if (refreshTriggeredBy == 'by_scheduled') {
        return;
      }
      const p1 = this.selectedDivisionIdSignal();
      const p2 = this.selectedGroupIdSignal();
      if (p1 && p2) {
        this.selectedDivisionId.set(p1);
        this.selectedGroupId = p2;
        this.search();
      }
    }, { allowSignalWrites: true });
  }

  ngOnInit(): void {
    this.currentTitle = this.title.getTitle();
    this.isLoggedIn = this.storageService.isLoggedIn();
  }

  search() {
    this.loading.set(true);
    this.gamesService.matchesByWeek(this.selectedDivisionId(), this.selectedGroupIdSignal(), false).subscribe((scheduledMatches: any) => {
      this.scheduledMatches.set(scheduledMatches);
      this.loading.set(false);
    });
  }

  getGames(games: any) {
    return games;
  }

  getMatches(matches: any) {
    return matches.data;
  }

  protected readonly Object = Object;
}
